<template>
  <MobileNavigation></MobileNavigation>

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 bg-white	" style="height:100%">
      <div class="grid grid-cols-2 gap-2 place-content-stretch ">
        <div class="bg-gray-200 rounded-lg text-center">
          <div class="font-weight-bold bg-gray-600 text-white rounded-full pt-5 pb-5 pl-4 pr-4" style="margin-top:20px; display:inline-block">Punch In</div>
          </div>
          <div class="bg-gray-200 pt-4 pl-2 pr-2 rounded-lg text-center">
            <div class="text-left">
              <h2 class="font-weight-bold">00:00 AM</h2>
              <h4>In Time</h4>
            </div>
            <div class="text-left">
              <h2 class="font-weight-bold">00:00 AM</h2>
              <h4>Out Time</h4>
            </div>
          </div>
      </div>

      <div class="rounded-lg bg-gray-200 h-48 mt-2 pt-2">
        <div class="grid grid-cols-2 gap-2 pl-2 pr-2 place-content-stretch">
            <div class="text-left">
              <h2 class="font-weight-bold">Some Text</h2>
              <h4>Some Text</h4>
            </div>

             <div class="text-left">
              <h2 class="font-weight-bold">Some Text</h2>
              <h4>Some Text</h4>
            </div>

            
             <div class="text-left">
              <h2 class="font-weight-bold">Some Text</h2>
              <h4>Some Text</h4>
            </div>

            
             <div class="text-left">
              <h2 class="font-weight-bold">Some Text</h2>
              <h4>Some Text</h4>
            </div>
        </div>
       
      </div>
    </div>    
</template>
<style>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .img-company-logo {
        width: 50px;
        height: 50px;
    }

    .no-decoration{
      text-decoration: none;
    }

    .no-decoration:hover{
      text-decoration: none;
    }

    </style>

<script>
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'


export default {
  props: ["sessions"],

  components: {
    MobileNavigation,
    Welcome,
    PageTitle,
    JetNavLink,

  },
  data() {
    return {
      title: "Login",
      username: null,
      password: null,

    };
  },
  methods: {
    getOrganisation() {
      axios.get("tenants/list").then((response) => {
      
      });
    },
  },
  mounted() {
    this.getOrganisation();
  },
};
</script>
